import {pushEvent} from "tracking/core/dispatcher";
import {EVENT_NAMES} from "tracking/core/eventNames";
import {ButtonClickPayload, PushOptions} from "tracking/core/types";

export function dataLayerButtonClick(
    label?: string | null,
    elementLocation?: string | null,
    url?: string | null,
    options?: PushOptions
) {
    const payload: ButtonClickPayload = {
        button_label: label ?? undefined,
        element_location: elementLocation ?? undefined,
        url: url ?? undefined,
    };

    pushEvent(EVENT_NAMES.BUTTON_CLICK, payload, options);
}
